import React from "react";
import { Link } from "react-router-dom";

import domain from 'src/config/domain';

const Logo = () => {
  const domainConfig = domain();
  return (
    <Link to={`/`} className="logo-link">
      <img 
        className={`logo-img ${domainConfig.isAcquirerFlow ? '-ml-2' : ''}`} 
        src={domainConfig.logoWhite} alt="logo" />
    </Link>
  );
};

export default Logo;
